import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import loginImage from '../../Assets/ogac.jpg';
import { signInWithGoogle } from '../../firebase';
import { glogin, login } from '../../Api/Api';
import { Link } from 'react-router-dom';
import { FcGoogle } from "react-icons/fc";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const LoginModal = ({ onClose, cart }) => {
  const [identifier, setMobile] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await login({ identifier, password });
      localStorage.setItem('user', JSON.stringify(response.user));
      localStorage.setItem('authToken', response.token);

      toast.success("Login successful!", { autoClose: 2000 });
      setTimeout(() => onClose(), 2000); // close after toast
    } catch (error) {
      toast.error(error?.response?.data?.error || "Login failed");
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithGoogle();
      const response = await glogin({
        g_id: result.user.uid,
        email: result.user.email,
        name: result.user.displayName
      });

      localStorage.setItem('authToken', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));

      toast.success(`Welcome, ${result.user.displayName}!`, { autoClose: 2000 });
      setTimeout(() => onClose(), 2000);
    } catch (error) {
      toast.error("Google login failed");
      console.error(error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center px-4">
      <ToastContainer />
      <div className="bg-white max-w-3xl w-full rounded-xl overflow-hidden flex flex-col md:flex-row shadow-lg relative">
        <div className="hidden md:block md:w-1/2">
          <img src={loginImage} alt="Login" className="w-full h-full object-cover" />
        </div>

        <div className="w-full md:w-1/2 p-6 relative min-h-[500px] flex flex-col justify-center">
          {!cart ? (
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-red-600"
            >
              <XMarkIcon className="w-5 h-5" />
            </button>
          ) : (
            <Link to="/" className="absolute top-4 left-4 text-blue-600 hover:underline">
              ← Back to home
            </Link>
          )}

          <h2 className="text-2xl font-bold text-[#0D004C] mb-6">Login</h2>

          <form onSubmit={handleLogin} className="space-y-4">
          <div>
  <label className="block text-sm font-medium text-gray-700 mb-1">
    Email or Mobile Number
  </label>
  <input
    type="text"
    required
    value={identifier}
    onChange={(e) => setMobile(e.target.value)}
    placeholder="Enter your email or 10-digit mobile number"
    className="w-full border border-gray-300 px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-[#0D004C]"
  />
</div>


            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-gray-300 px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-[#0D004C]"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-[#0D004C] text-white font-semibold py-2 rounded hover:bg-[#1a1460] transition"
            >
              Login
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600 mb-2">OR</p>
            <button
              onClick={handleGoogleLogin}
              className="w-full border border-gray-300 py-2 rounded hover:bg-gray-100 transition flex items-center justify-center gap-2"
            >
              <FcGoogle size={30} />
              <span>Continue with Google</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
